<template>
  <v-card
    v-click-outside="close"
    v-bind="{
      ...$props,
      ...$attrs,
    }"
    :min-width="minWidth"
    class="pl-4 pb-2 pt-4 filter-menu-card"
  >
    <AsyncDpplTreeselect
      v-if="isOpen"
      :key="field.id"
      v-model="treeselectModel"
      :async="field.async"
      :options="field.options"
      :async-url="field.asyncUrl"
      placeholder="Type to begin search"
      label="Selected Filters"
      show-select-all
      show-inline-apply
      flat
      @apply-filters="$emit('apply-filters')"
      @add-snackbar="$emit('add-snackbar', $event)"
    />
  </v-card>
</template>

<script>
import { defineAsyncComponent } from 'vue';

// Loads the treeselect only when needing to be rendered
const AsyncDpplTreeselect = defineAsyncComponent(() => import('@/components/datapeople/DpplTreeselect.vue'));

export default {
  name: 'FilterMenuCard',
  components: {
    AsyncDpplTreeselect,
  },
  props: {
    field: { type: Object, default: () => ({}) },
    isOpen: { type: Boolean, default: false },
    minWidth: { type: String, default: '455' },
  },
  emits: ['set-temp-filters', 'set-to-applied-filters', 'apply-filters', 'add-snackbar'],
  computed: {
    treeselectModel: {
      get() {
        return this.field.value;
      },
      set(value) {
        this.$emit('set-temp-filters', value);
      },
    },
  },
  watch: {
    isOpen(isOpen) {
      if (!isOpen) {
        this.$emit('set-to-applied-filters');
      }
    },
  },
  methods: {
    close() {
      if (this.isOpen) {
        this.$emit('set-to-applied-filters');
      }
    },
  },
};
</script>

<style lang="less" scoped>
.v-card {
  overflow: hidden !important;
  box-shadow: 0px 0px 50px fade(@grey-900, 10%) !important;
}
</style>
